// Opens a print window with one shipping label per order (name, address, date).
// Builds the DOM with createElement + textContent so all order data is
// auto-escaped (no document.write / innerHTML -> no XSS from order fields).
export function printLabels(orders, day) {
  const win = window.open("", "_blank");
  if (!win) { alert("Please allow pop-ups to print labels."); return; }
  const doc = win.document;

  doc.title = `Shipping Labels ${day || "all"}`;

  const style = doc.createElement("style");
  style.textContent = `
    * { box-sizing: border-box; }
    body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 12px; }
    .meta { margin-bottom: 10px; font-size: 12px; color: #444; }
    .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
    .label { border: 2px solid #1B4332; border-radius: 10px; padding: 14px; page-break-inside: avoid; }
    .brand { font-size: 10px; letter-spacing: 1px; color: #2D6A4F; font-weight: bold; text-transform: uppercase; }
    .oid { font-size: 11px; color: #666; margin: 4px 0 10px; }
    .to { font-size: 10px; color: #888; letter-spacing: 1px; }
    .name { font-size: 17px; font-weight: bold; color: #111; margin-top: 2px; }
    .addr { font-size: 14px; color: #222; }
    .items { margin-top: 10px; font-size: 11px; color: #666; border-top: 1px dashed #ccc; padding-top: 6px; }
    @media print { .noprint { display: none; } }
  `;
  doc.head.appendChild(style);

  // meta bar with a real Print button (no inline onclick string)
  const meta = doc.createElement("div");
  meta.className = "meta noprint";
  meta.textContent = `${orders.length} label(s) for ${day || "all dates"} — `;
  const printBtn = doc.createElement("button");
  printBtn.textContent = "Print now";
  printBtn.addEventListener("click", () => win.print());
  meta.appendChild(printBtn);
  doc.body.appendChild(meta);

  const grid = doc.createElement("div");
  grid.className = "grid";

  orders.forEach((o) => {
    const c = o.customer || {};
    const label = doc.createElement("div");
    label.className = "label";
    const add = (cls, text) => {
      const d = doc.createElement("div");
      d.className = cls;
      d.textContent = text; // textContent escapes any HTML in the data
      label.appendChild(d);
    };
    add("brand", "British Supplements · Made in the UK");
    add("oid", `Order ${o.order_id || ""}  |  ${(o.created_at || "").slice(0, 10)}`);
    add("to", "SHIP TO:");
    add("name", c.name || "");
    add("addr", c.address || "");
    add("addr", `${c.city || ""}, ${c.postcode || ""}`);
    add("addr", c.country || "");
    add("items", (o.items || []).map((i) => `${i.name} x${i.qty}`).join(", "));
    grid.appendChild(label);
  });

  doc.body.appendChild(grid);

  win.focus();
  setTimeout(() => win.print(), 400);
}
